import { render } from "./SettingsHome.vue?vue&type=template&id=0bbb6a27&scoped=true"
import script from "./SettingsHome.vue?vue&type=script&lang=js"
export * from "./SettingsHome.vue?vue&type=script&lang=js"

import "./SettingsHome.vue?vue&type=style&index=0&id=0bbb6a27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbb6a27"]])

export default __exports__